import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import type { CondorLambda } from 'config-editor-common';
import { CondorLambdaListEditor } from 'config-editor';
import { useRecordField } from '../fieldState';

interface UiOptions {
  defaultsFieldName?: string;
}

type Props = FieldExtensionComponentProps<Record<string, CondorLambda>, UiOptions>;

export function CondorLambdaEditor(props: Props) {
  const { items, defaults, commit } = useRecordField<CondorLambda>(props);

  return (
    <CondorLambdaListEditor
      lambdas={items}
      defaults={defaults}
      showDefaults={false}
      onChange={commit}
    />
  );
}
